module.exports = __webpack_public_path__ + "img/icon (19).fc9d6a2a.png";